import HttpService from './commons/HttpService';

const AccountsReceivableService = {
  save(accountsReceivable) {
    if (accountsReceivable.id && accountsReceivable.id > 0) {
      return this.update(accountsReceivable);
    }
    return this.create(accountsReceivable);
  },
  createComandaCharge(accountsReceivable) {
    return HttpService.post('/accountsReceivables/comandaCharge', accountsReceivable);
  },
  updateComandaCharge(comandaChargeInfo) {
    return HttpService.put(`/accountsReceivables/comandaCharge/${comandaChargeInfo.id}`, comandaChargeInfo);
  },
  createWithComandaInfo(accountsReceivable) {
    return HttpService.post('/accountsReceivables/withComandaInfo', accountsReceivable);
  },
  create(accountsReceivable) {
    return HttpService.post('/accountsReceivables', accountsReceivable);
  },
  update(accountsReceivable) {
    return HttpService.put(`/accountsReceivables/${accountsReceivable.id}`, accountsReceivable);
  },
  delete(accountsReceivable) {
    return HttpService.delete(`/accountsReceivables/${accountsReceivable.id}`);
  },
  openOrClose({ accountsReceivableId, opened }) {
    return HttpService.put(`/accountsReceivables/${accountsReceivableId}/${opened ? 'opened' : 'closed'}`);
  },
  getById(id) {
    return HttpService.get(`/accountsReceivables/${id}`);
  },
  getComandaChargeById(id) {
    return HttpService.get(`/accountsReceivables/comandaCharge/${id}`);
  },
  findAllForCurrentUser({ opened, customerId }) {
    return HttpService.get('/accountsReceivables', { params: { opened, customerId } });
  },
  existsOpen(customerId) {
    return HttpService.get('/accountsReceivables/opened', { params: { customerId } });
  },
  findOpenedList(customerId) {
    return HttpService.get('/accountsReceivables/openedList', { params: { customerId } });
  },
  searchForCurrentUser({ customerName, opened, startDate, endDate }) {
    return HttpService.get('/accountsReceivables/search', {
      params: { customerName, opened, startDate, endDate },
    });
  },

  getAllForCustomerByOpened(customerId, opened) {
    return HttpService.get(`/customers/${customerId}/comandas`, {
      params: { customerId, opened },
    });
  },

  getAllForCustomerByOpenedAndDateRange({ customerId, opened, startDate, endDate }) {
    return HttpService.get(`/customers/${customerId}/comandas`, {
      params: { customerId, opened, startDate, endDate },
    });
  },

  getAllOpened() {
    return HttpService.get('/accountsReceivables/allOpened', {
      params: { opened: true },
    });
  },

  getItemsWithStatus(accountsReceivableId) {
    return HttpService.get(`/accountsReceivables/${accountsReceivableId}/servicePackageStatus`, {
      params: { accountsReceivableId },
    });
  },

  createPayment(payment) {
    return HttpService.post(`/accountsReceivables/${payment.accountsReceivableId}/payments`, payment);
  },
  deletePayment(payment) {
    return HttpService.delete(`/accountsReceivables/${payment.accountsReceivableId}/payments/${payment.id}`);
  },
  getPayments(accountsReceivableId) {
    return HttpService.get(`/accountsReceivables/${accountsReceivableId}/payments`, {
      params: { accountsReceivableId },
    });
  },
  getAppointments(accountsReceivableId) {
    return HttpService.get(`/accountsReceivables/${accountsReceivableId}/appointments`, {
      params: { accountsReceivableId },
    });
  },
  generateReceipt(accountsReceivableId) {
    return HttpService.post(`/accountsReceivables/${accountsReceivableId}/receiptFile`, null, {
      responseType: 'arraybuffer',
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      const fileName = 'recibo_comanda_' + new Date().getTime() + '.pdf';
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    });
  },

  findAppointmentsForComandaChargeWithPaymentsByCustomerId(customerId) {
    return HttpService.get('/accountsReceivables/comandaCharge/appointmentsWithPayments', {
      params: { customerId },
    });
  },

  findAppointmentsForComandaChargeByCustomerId(customerId, includeFutureAppointments) {
    return HttpService.get('/accountsReceivables/comandaCharge/appointments', {
      params: { customerId, includeFutureAppointments },
    });
  },
  findAppointmentsForComandaChargeByComandaId(comandaId, includeFutureAppointments) {
    return HttpService.get('/accountsReceivables/comandaCharge/appointments', {
      params: { comandaId, includeFutureAppointments },
    });
  },
};

export default AccountsReceivableService;
